// Library imports
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import styled from "styled-components";
import Carousel from "react-multi-carousel";

// Local imports
import ListCard from "../../Shared/ListCard";
import GenericSearch from "modules/Campaigns/Shared/GenericSearch";
import PersonBadgeItem from "./PersonBadgeItem";
import ButtonRightIconGreen from "../../../Common/Components/ButtonRightIconGreen";
import DoneGreen from "../../../../assets/img/icons/tick-white.svg";
import { searchPeople, searchLists, clearPeopleSearch, clearListSearch, dynamicAudienceSearch } from "../actions";
import { DYNAMIC_AUDIENCE_MATCHING } from "constants/actionTypes";
import { getQueryListId } from "utils";

interface IPeopleAndListProps {
  onClickAudienceDone?: any;
  handleAddPeople?: any;
  selectedContactIds?: number[];
  selectedListIds?: number[];
  addedContactIds?: number[];
  addedListIds?: number[];
  hideRecommendedList?: boolean;
  isPersonAdded?: any;
  enableScrollForContacts?: boolean;
  disableMaxHeight?: boolean;
  inContactList?: boolean;
  inCreateCampaign?: boolean;
  inPublish?: boolean;
  inCreateNewList?: boolean;
  selectAllFlag?: boolean;
  unselectedContactIdsState?: string[];
  isOpened?: boolean;
}

const PeopleAndList: React.FC<IPeopleAndListProps> = ({
  onClickAudienceDone,
  handleAddPeople,
  selectedContactIds = [],
  selectedListIds = [],
  addedContactIds = [],
  addedListIds = [],
  hideRecommendedList = false,
  isPersonAdded,
  enableScrollForContacts,
  disableMaxHeight,
  inCreateNewList,
  selectAllFlag,
  unselectedContactIdsState,
  isOpened,
}) => {
  //Local States
  const [dynamicKeywordsState, setdynamicKeywordsState] = useState<string[]>([]);
  const [dynamicPeopleMode, setDynamicPeopleMode] = useState(false);
  const [searchPeopleMode, setSearchPeopleMode] = useState(false);
  const [searchListMode, setSearchListMode] = useState(false);
  const [searchedPeopleData, setSearchedPeopleData] = useState<any>([]);
  const [dynamicPeopleData, setDynamicPeopleData] = useState<any>([]);
  const [recommendedPeopleData, setRecommendedPeopleData] = useState<any>([]);
  const [skipFirstMount, setSkipFirstMount] = useState(false);

  // Redux States
  const recommendedAudienceList = useSelector((state: RootState) => state.recommendedLists.data);
  const recommendedListsLoading = useSelector((state: RootState) => state.recommendedLists.loading);
  const recommendedAudienceContact = useSelector((state: RootState) => state.recommendedPeople.data);
  const recommendedContactsLoading = useSelector((state: RootState) => state.recommendedPeople.loading);
  const peopleSearchResults = useSelector((state: RootState) => state.searchRecommendedPeople.data);
  const peopleSearchLoading = useSelector((state: RootState) => state.searchRecommendedPeople.loading);
  const listSearchResults = useSelector((state: RootState) => state.searchRecommendedList.data);
  const listSearchLoading = useSelector((state: RootState) => state.searchRecommendedList.loading);
  const dynamicKeywords = useSelector((state: RootState) => state.recommendedPeople.dynamicKeywords);
  const dynamicAudienceData = useSelector((state: RootState) => state.recommendedPeople.dynamicAudienceData);
  const dynamicAudienceloading = useSelector((state: RootState) => state.recommendedPeople.dynamicAudienceloading);
  const closeCreateNewListAsiderCheck = useSelector(
    (state: RootState) => state.uiReducer.closeCreateNewListAsiderCheck
  );
  const closeCreateNewListAsiderFromCancelCheck = useSelector(
    (state: RootState) => state.uiReducer.closeCreateNewListAsiderFromCancelCheck
  );
  const alreadySelectedContacts = useSelector(
    (state: RootState) => state.recommendedPeople.alreadySelectedContacts
  ); // this state contains the ids of the contacts that are already selected when creating new list
  const searchTerm = useSelector((state: RootState) => state.recommendedPeople.searchTerm);
  const audienceFiltersApplied: boolean = useSelector(
    (state: RootState) => state.uiReducer.audienceFiltersApplied
  );

  // Local Variables
  const responsiveV = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 2501 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 2500, min: 1476 },
      items: 4,
    },
    mindesktoplg: {
      breakpoint: { max: 1475, min: 1251 },
      items: 3,
    },
    mindesktop: {
      breakpoint: { max: 1250, min: 1025 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  const ContactsLoading = dynamicAudienceloading || recommendedContactsLoading || peopleSearchLoading; // this const will be true if any of the loading states are true

  // Component Logic
  useEffect(() => {
    return () => setSearchPeopleMode(false);
  }, []);
  useEffect(() => {
    if (searchPeopleMode) setSearchPeopleMode(false);
  }, [closeCreateNewListAsiderCheck, closeCreateNewListAsiderFromCancelCheck]);

  useEffect(() => {
    if (skipFirstMount) {
      if (dynamicKeywords && dynamicKeywords?.length > 0) {
        setdynamicKeywordsState(dynamicKeywords);
        setDynamicPeopleMode(true);
        setSearchPeopleMode(false);
      } else {
        setdynamicKeywordsState([]);
        setDynamicPeopleMode(false);
        if (searchTerm.length === 0) setSearchPeopleMode(false);
        else {
          setSearchPeopleMode(true);
          console.log("1: ");
          searchPeople(searchTerm, false, selectAllFlag, getQueryListId.toString(), unselectedContactIdsState);
        }
      }
    } else {
      setSkipFirstMount(true);
    }
  }, [dynamicKeywords]);

  useEffect(() => {
    if (searchPeopleMode && peopleSearchResults.length > 0) {
      const searchedPeopleDataHelper: any = peopleSearchResults.filter((item: any) => {
        // remove already selected people from searched audience results
        if (!alreadySelectedContacts.includes(item.id)) return item;
      });
      setSearchedPeopleData(searchedPeopleDataHelper);
    } else {
      setSearchedPeopleData([]);
    }
  }, [peopleSearchResults, searchPeopleMode]);

  useEffect(() => {
    if (dynamicPeopleMode && dynamicAudienceData.length > 0) {
      const dynamicPeopleDataHelper: any = dynamicAudienceData.filter((item: any) => {
        // remove already selected people from dynamic audience results
        if (!alreadySelectedContacts.includes(item.id)) return item;
      });
      setDynamicPeopleData(dynamicPeopleDataHelper);
    } else {
      setDynamicPeopleData([]);
    }
  }, [dynamicAudienceData, dynamicPeopleMode]);

  useEffect(() => {
    if (recommendedAudienceContact.length > 0) {
      const recommendedPeopleDataHelper: any = recommendedAudienceContact.filter((item: any) => {
        // remove already selected people from recommended audience results
        if (!alreadySelectedContacts.includes(item.id)) return item;
      });
      setRecommendedPeopleData(recommendedPeopleDataHelper);
    } else {
      setRecommendedPeopleData([]);
    }
  }, [recommendedAudienceContact, isOpened]);

  function searchHandler(value: string, searchType: string) {
    if (value.length > 0) {
      if (dynamicKeywordsState.length > 0) {
        dynamicAudienceSearch(
          value,
          dynamicKeywords?.join(","),
          selectAllFlag,
          getQueryListId.toString(),
          unselectedContactIdsState
        );
      } else {
        if (searchType === "contact") {
          setSearchPeopleMode(true);
          setDynamicPeopleMode(false);
          searchPeople(value, false, selectAllFlag, getQueryListId.toString(), unselectedContactIdsState);
        } else if (searchType === "list") {
          setSearchListMode(true);
          clearListSearch();
          searchLists(value, false);
        }
      }
      store.dispatch({
        type: DYNAMIC_AUDIENCE_MATCHING.SEARCH_TERM,
        searchTerm: value,
      });
    } else {
      if (searchType === "contact") {
        clearPeopleSearch();
        setSearchPeopleMode(false);
        setDynamicPeopleMode(false);
      } else if (searchType === "list") {
        setSearchListMode(true);
        clearListSearch();
        searchLists(value, false);
      }
    }
  }

  function handleCancelPeopleSearch() {
    if (dynamicKeywordsState.length > 0) {
      dynamicAudienceSearch(
        "",
        dynamicKeywords?.join(","),
        selectAllFlag,
        getQueryListId.toString(),
        unselectedContactIdsState
      );
      store.dispatch({
        type: DYNAMIC_AUDIENCE_MATCHING.SEARCH_TERM,
        searchTerm: "",
      });
      setSearchPeopleMode(false);
      setDynamicPeopleMode(true);
    } else {
      setSearchPeopleMode(false);
      setDynamicPeopleMode(false);
      clearPeopleSearch();
    }
  }

  function handleCancelListSearch() {
    setSearchListMode(false);
    clearListSearch();
  }
  return (
    <Wrapper displayScroll={`${enableScrollForContacts ? "" : "none"}`} disableMaxHeight={disableMaxHeight}>
      <div className="head-wrapper">
        <h3 className="heading">Recommended Contacts</h3>
        <div className="search-wrapper">
          <GenericSearch
            handleSearch={(value: string) => {
              searchHandler(value, "contact");
            }}
            handleClear={handleCancelPeopleSearch}
            placeholder="Search contacts..."
            className="search-wrapper-two"
          />
        </div>
      </div>

      <div className={hideRecommendedList ? "recommended-people full-height-users" : "recommended-people"}>
        {ContactsLoading ? <p>Loading...</p> : null}

        {dynamicPeopleMode
          ? !ContactsLoading && dynamicPeopleData.length > 0
            ? dynamicPeopleData?.map((contactItem: any) => (
                <PersonBadgeItem
                  key={contactItem.id}
                  email={contactItem.email}
                  contact_id={contactItem.id}
                  image={contactItem.thumbnail ? contactItem.thumbnail : ""}
                  personalityType={contactItem.personality_details.archetype}
                  userName={contactItem.name.trim() || contactItem.email.trim()}
                  pColor={contactItem.personality_details.color}
                  handleAddPeople={handleAddPeople}
                  disabled={selectedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                  added={addedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                />
              ))
            : !ContactsLoading && (
                <p className="empty-message">No audience matched against your Dynamic keywords!</p>
              )
          : null}

        {!searchPeopleMode && !dynamicPeopleMode ? (
          !ContactsLoading && recommendedPeopleData.length > 0 ? (
            recommendedPeopleData?.map((contactItem: any) => (
              <PersonBadgeItem
                key={contactItem.id}
                email={contactItem.email}
                contact_id={contactItem.id}
                image={contactItem.thumbnail ? contactItem.thumbnail : ""}
                personalityType={contactItem.personality_details.archetype}
                userName={contactItem.name.trim() || contactItem.email.trim()}
                pColor={contactItem.personality_details.color}
                handleAddPeople={handleAddPeople}
                disabled={selectedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                added={addedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
              />
            ))
          ) : !ContactsLoading ? (
            selectAllFlag && !audienceFiltersApplied && recommendedPeopleData.length === 0 ? (
              <p className="empty-message">All the recommended contacts are already added!</p>
            ) : (
              <p className="empty-message">
                You haven’t published any campaign yet, system will recommend contacts here for campaign audience
                based on users’ engagement.
              </p>
            )
          ) : null
        ) : null}

        {searchPeopleMode
          ? !ContactsLoading && searchedPeopleData.length > 0
            ? searchedPeopleData?.map((contactItem: any) => (
                <PersonBadgeItem
                  key={contactItem}
                  contact_id={contactItem.id}
                  email={contactItem.email}
                  image={contactItem.thumbnail ? contactItem.thumbnail : ""}
                  personalityType={contactItem.personality_details.archetype}
                  userName={contactItem.name.trim() || contactItem.email.trim()}
                  pColor={contactItem.personality_details.color}
                  handleAddPeople={handleAddPeople}
                  disabled={selectedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                  added={addedContactIds?.indexOf(contactItem.id) >= 0 ? true : false}
                />
              ))
            : !ContactsLoading && <p>No audience found againt your search!</p>
          : null}
      </div>

      {!hideRecommendedList && (
        <div className="head-wrapper space-top">
          <h3 className="heading">Recommended List</h3>
          <div className="search-wrapper">
            <GenericSearch
              handleSearch={(value: string) => {
                searchHandler(value, "list");
              }}
              handleClear={handleCancelListSearch}
              placeholder="Search lists..."
            />
          </div>
        </div>
      )}

      {!hideRecommendedList &&
      searchListMode === false &&
      listSearchLoading === false &&
      recommendedListsLoading === false &&
      recommendedAudienceList.length === 0 ? (
        <p className="empty-message">
          System will recommend lists here to include in campaign audience based on users’ engagement once you
          published any campaign.
        </p>
      ) : searchListMode && listSearchResults.length === 0 && !listSearchLoading ? (
        <p>No results found against your search.</p>
      ) : null}

      {!hideRecommendedList && (
        <>
          {recommendedListsLoading || listSearchLoading ? <p>Loading...</p> : null}
          <Carousel
            responsive={responsiveV}
            containerClass="carousel-container"
            renderButtonGroupOutside={true}
            arrows={true}
          >
            {!searchListMode &&
              !listSearchLoading &&
              !recommendedListsLoading &&
              recommendedAudienceList?.map((listItem, index) => (
                <div key={index} className="mx-2">
                  <ListCard
                    key={index}
                    classname={`list-card-sm ${selectedListIds?.indexOf(listItem.id) >= 0 ? "show-selected" : ""}`}
                    list={listItem}
                    isList={true}
                    handleAddPeople={handleAddPeople}
                    added={addedListIds.indexOf(listItem.id) >= 0 ? true : false}
                  />
                </div>
              ))}
          </Carousel>
          <Carousel
            responsive={responsiveV}
            containerClass="carousel-container"
            renderButtonGroupOutside={true}
            arrows={true}
          >
            {searchListMode &&
              listSearchResults?.map((listItem, index) => (
                <div key={index} className="mx-2">
                  <ListCard
                    key={index}
                    classname={`list-card-sm ${selectedListIds?.indexOf(listItem.id) >= 0 ? "show-selected" : ""}`}
                    list={listItem}
                    isList={true}
                    handleAddPeople={handleAddPeople}
                    added={addedListIds.indexOf(listItem.id) >= 0 ? true : false}
                  />
                </div>
              ))}
          </Carousel>
        </>
      )}
      {!inCreateNewList ? (
        <div className="footer-wrapper">
          <ButtonRightIconGreen
            icon={DoneGreen}
            label="Done"
            classBtn="done-btn"
            data-id="qa-btn-done"
            onClick={onClickAudienceDone}
          />
        </div>
      ) : null}
    </Wrapper>
  );
};

export default PeopleAndList;

interface IWrapperProps {
  displayScroll?: any;
  disableMaxHeight?: boolean;
}

const Wrapper = styled("div")<IWrapperProps>`
  .inner-wrapper {
    width: 100% !important;
    margin-top: 0 !important;
  }
  .carousel-container {
    margin: 0 -8px;
    min-width: calc(100vw - 1270px);
    .react-multi-carousel-track {
      min-width: 100%;
    }
    .react-multi-carousel-item {
      flex: none !important;
    }
    .react-multiple-carousel__arrow {
      position: absolute;
      outline: 0;
      right: 20px;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      border-radius: 35px;
      z-index: 10;
      border: 0;
      background: #fff;
      min-width: 43px;
      min-height: 43px;
      opacity: 1;
      cursor: pointer;
      box-shadow: 0 0 14px 5px rgb(0 0 0 / 10%);
      top: 30%;
      &.react-multiple-carousel__arrow--left {
        min-width: 43px;
        width: 43px;
        &::before {
          margin-left: -3px;
        }
      }
      &.react-multiple-carousel__arrow--right {
        min-width: 43px;
        width: 43px;
        &::before {
          margin-right: -4px;
        }
      }
      &::before {
        color: #424b50;
      }
    }
  }
  .footer-wrapper {
    padding: 20px 0px;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    width: 100%;
    bottom: 10px;
    right: 24px;
    .done-btn {
      .icon {
        img {
          width: 14px;
        }
      }
    }
  }
  .head-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: start !important;
    .heading {
      font-family: "Roboto Slab", serif;
      font-weight: 600;
      color: #424b50;
      font-size: 22px;
      margin-top: 0px;
      line-height: 30px;
      margin-bottom: 11px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 16px;
      }
    }
    .search-wrapper {
      width: 175px;
    }
    &.space-top {
      margin-top: 30px;
      margin-bottom: 20px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 15px;
        margin-bottom: 0px;
      }
    }
  }
  .recommended-people {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow-x: hidden;
    margin-top: 20px;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    max-height: calc(100vh - 565px);
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-height: calc(100vh - 430px);
      margin-top: 0px;
    }
    &.full-height-users {
      height: calc(100vh - 180px);
      min-height: calc(100vh - 180px);
    }
    &::-webkit-scrollbar {
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  p {
    color: #424b50;
  }
  p.empty-message {
    font-weight: bold;
    font-size: 16px;
  }
`;
